import script from "./SidebarView.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarView.vue?vue&type=script&setup=true&lang=js"

import "./SidebarView.vue?vue&type=style&index=0&id=63e6a055&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63e6a055"]])

export default __exports__